import { v4 as uuidv4 } from "uuid";

import ReactDOM from "react-dom";
import { makeAutoObservable, reaction } from "mobx";
import { observer } from "mobx-react-lite";
import { FoodItemProperties } from "../../Resources/Constants";

class Food {
  // code = null; //Used for the aux foods when adding on AddFoodView

  equivalences = [];
  isShowingEquivalences = false;

  isSelected = null;

  constructor(
    id = uuidv4(),
    name = "",
    order = 0,
    quantity = 100, //Use grams for now, like Harbiz
    calories = 0, //nutriments -> energy_kcal_100g
    carbs = 0, //nutriments -> carbohydrates_100g
    protein = 0, //nutriments -> proteins_100g
    fats = 0, //nutriments -> fat_100g
    code = uuidv4().toString(),
    brand = null, //brands
    store = null, //stores
    foodOption = null,
    client = null, //For last used foods
    coach = null, //For custom foods
    food = null
  ) {
    this.id = id;
    this.name = name;
    this.order = order;
    this.quantity = quantity;
    this.calories = calories;
    this.carbs = carbs;
    this.protein = protein;
    this.fats = fats;
    this.code = code;
    this.brand = brand;
    this.store = store;
    this.foodOption = foodOption;
    this.client = client;
    this.coach = coach;
    this.food = food;
    makeAutoObservable(this);
  }

  uploadToCloud(isLibrary = false) {
    let equivalencesArray = this.equivalences.map((food) =>
      food.uploadToCloud()
    );

    return {
      id: this.id.toString().toLowerCase(),
      name: this.name,
      order: this.order,
      // quantity: this.quantity,
      ...(!isLibrary && { quantity: this.quantity }),
      ...(!this.code && { code: this.code.toLowerCase() }),
      calories: this.calories,
      carbs: this.carbs,
      protein: this.protein,
      fats: this.fats,
      ...(this.equivalences.length > 0 && { equivalences: equivalencesArray }),
    };
  }

  fetchEquivalence(foodData) {
    const newFood = new Food(
      foodData.id,
      foodData.name,
      foodData.order,
      foodData.quantity,
      foodData.calories,
      foodData.carbs,
      foodData.protein,
      foodData.fats,
      foodData.code ?? undefined,
      null,
      null,
      null,
      null,
      null,
      this
    );

    this.equivalences.push(newFood);
  }

  get getCalories() {
    const perGram = this.calories / 100;
    const total = perGram * this.quantity;
    return Math.max(0, total);
  }

  get getCarbs() {
    const perGram = this.carbs / 100;
    const total = perGram * this.quantity;
    return Math.max(0, total);
  }

  get getProtein() {
    const perGram = this.protein / 100;
    const total = perGram * this.quantity;
    return Math.max(0, total);
  }

  get getFats() {
    const perGram = this.fats / 100;
    const total = perGram * this.quantity;
    return Math.max(0, total);
  }

  adjustKcal(kcalTarget) {
    if (typeof kcalTarget !== "number" || kcalTarget <= 0) return;

    const currentCalories = this.getCalories;
    if (currentCalories === 0) return;

    const ratio = kcalTarget / currentCalories;
    const newQty = this.quantity * ratio;

    // round up to the next whole gram
    this.quantity = Math.ceil(newQty);
  }

  selectEquivalence(foodItem) {
    // guard against missing code
    if (!foodItem.code) return;

    // find the index of the item in foods
    const idx = this.equivalences.findIndex((f) => f.code === foodItem.code);

    if (idx > -1) {
      // already selected → remove it
      this.equivalences.splice(idx, 1);
    } else {
      // not selected → add it
      this.addEquivalence(foodItem);
    }
  }

  addEquivalence(foodItem, historyFood) {
    const maxOrder = this.equivalences.length
      ? Math.max(...this.equivalences.map((f) => f.order))
      : -1;
    const newOrder = maxOrder + 1;

    if (historyFood) {
      const newFoodToAdd = new Food(
        uuidv4(),
        historyFood.name,
        newOrder,
        undefined,
        historyFood.calories,
        historyFood.carbs,
        historyFood.protein,
        historyFood.fats,
        historyFood.code,
        historyFood.brand,
        historyFood.store,
        null,
        null,
        null,
        this
      );

      newFoodToAdd.setProperty("code", historyFood.code);

      newFoodToAdd.adjustKcal(this.getCalories);

      this.equivalences.push(newFoodToAdd);
    } else {
      const newFoodToAdd = new Food(
        uuidv4(),
        foodItem.product_name || foodItem.generic_name,
        newOrder,
        undefined,
        foodItem.nutriments?.[FoodItemProperties.CALORIES],
        foodItem.nutriments?.[FoodItemProperties.CARBS],
        foodItem.nutriments?.[FoodItemProperties.PROTEIN],
        foodItem.nutriments?.[FoodItemProperties.FAT],
        foodItem.code, //Revisar!!!!
        foodItem.brands,
        foodItem.stores,
        null,
        null,
        null,
        this
      );

      newFoodToAdd.setProperty("code", foodItem.code);

      newFoodToAdd.adjustKcal(this.getCalories);

      this.equivalences.push(newFoodToAdd);

      // if (
      //   this.meal &&
      //   this.meal.nutritionPlan &&
      //   this.meal.nutritionPlan.client
      // ) {
      //   const client = this.meal.nutritionPlan.client;
      //   const history = client.foodHistory;

      //   const alreadyInHistory = history.some(
      //     (f) => f.code === newFoodToAdd.code
      //   );
      //   if (!alreadyInHistory) {
      //     const newLastUsedFood = new Food(
      //       uuidv4(),
      //       newFoodToAdd.name,
      //       newOrder,
      //       undefined,
      //       newFoodToAdd.calories,
      //       newFoodToAdd.carbs,
      //       newFoodToAdd.protein,
      //       newFoodToAdd.fats,
      //       newFoodToAdd.code,
      //       newFoodToAdd.brand,
      //       newFoodToAdd.store,
      //       null,
      //       client
      //     );
      //     newLastUsedFood.setProperty("code", newFoodToAdd.code);

      //     history.push(newLastUsedFood);

      //     // **keep only the last 20 items**
      //     if (history.length > 20) {
      //       history.shift();
      //     }
      //   }
      // }
    }
  }

  deleteEquivalence(foodId) {
    console.log("deleteEquivalence");
    const idx = this.equivalences.findIndex((f) => f.id === foodId);

    if (idx > -1) {
      // already selected → remove it
      this.equivalences.splice(idx, 1);
    }
  }

  // Generic setter
  setProperty(propertyName, value) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      this[propertyName] = value;
    } else {
      console.error(`Property ${propertyName} does not exist.`);
    }
  }

  // Generic getter
  getProperty(propertyName) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      return this[propertyName];
    } else {
      console.error(`Property ${propertyName} does not exist.`);
      return undefined;
    }
  }
}
export default Food;
